package ext

import common.dto.Quat
import three.js.Quaternion

fun Quat.asQuaternion(): Quaternion {
    return Quaternion(x, y, z, w)
}

fun Quaternion.asQuat(): Quat {
    return Quat(x.toDouble(), y.toDouble(), z.toDouble(), w.toDouble())
}

fun Quaternion.set(quat: Quat): Quaternion {
    return set(quat.x, quat.y, quat.z, quat.w)
}